import React, { useState, useEffect } from "react";
import InputField from "./InputField";
import { UniqueNumber } from "unique-string-generator";
import Axios from "axios";
import { useNavigate } from "react-router-dom";
// import "./PostBuilder.css";
import ParagraphInput from "./ParagraphInput";
import ImageInput from "./ImageInput";
import ImageImageInput from "./ImageImageInput";
import ImageParagraphInput from "./ImageParagraphInput";
import ParagraphImageInput from "./ParagraphImageInput";
import { useAuth } from "./Context/AuthContext";

const postId = UniqueNumber().toString();

const PostBuilder = () => {
  const { appUser, setUser, isLogin, setLogin } = useAuth();
  const navigate = useNavigate();
  const [post, setPost] = useState([]);
  const [temp, setTemp] = useState(0);
  const allowDrop = (event) => {
    event.preventDefault();
  };
  const addElement = (event) => {
    const element = event.dataTransfer.getData("text/plain");
    if (element === "paragraph") {
      setTemp(temp + 1);
      setPost([...post, <ParagraphInput postId={postId} id={temp} />]);
    } else if (element === "image") {
      setTemp(temp + 1);
      setPost([...post, <ImageInput postId={postId} id={temp} />]);
    } else if (element === "image_and_paragraph") {
      setTemp(temp + 1);
      setPost([...post, <ImageParagraphInput postId={postId} id={temp} />]);
    }
    // else if (element === 'paragraph_and_image') {
    //     setTemp(temp + 1);
    //     setPost([...post, <ParagraphImageInput postId={postId} id={temp} />]);
    // }
    // else if(element==='image_and_image'){
    //     setTemp(temp + 1);
    //     setPost([...post, <ImageImageInput postId={postId} id={temp} />]);
    // }
  };
  const generatePost = () => {
    let postTitle = document.getElementById("post_title").value;
    Axios.post("https://fitness-junction-bots.onrender.com/api/generatepost", {
      userEmail: appUser.email,
      userName: appUser.displayName,
      postId: postId,
      postTitle: postTitle,
    })
      .then((data) => {})
      .catch((error) => console.log(error));

    window.location.reload();
  };
  return (
    <div className="postbuilder-container shadow-sm">
      <h2 className="text-center pt-3">Write your post</h2>
      <div
        // className="postbuilder-container row"
        className="row align-items-center  "
      >
        <div className="col-lg-6 col-sm-12">
          <InputField />
        </div>
        <div
          id="post_container"
          // className=" form-control p-2"
          className="col-6 post-container"
          onDrop={addElement}
          onDragOver={allowDrop}
        >
          <input
            type="text"
            id="post_title"
            className="post-title w-100 p-2 form-control "
            placeholder="Add title here"
            required="required"
          />
          {post.map((element, index) => (
            <div className="i-container">{element}</div>
          ))}
          <button
            type="button"
            className=" btn bot-btn w-100 mt-2 mx-auto"
            onClick={generatePost}
          >
            Add Post
          </button>
        </div>
      </div>
    </div>
  );
};

export default PostBuilder;
